import { createSelector } from '@reduxjs/toolkit';

import { radarUserDataPlainSelector } from '@lootboy/lib/slices/radarUserProfile';

import { loginCometChat, logoutCometChat } from '~/middlewares/comet-chat';
import { observeStore } from '~/redux/obesrvers/observeStore';

const select = createSelector(
  radarUserDataPlainSelector,
  ({ userData: { uid } } = {}) => uid,
);

const onChange = (uid, dispatch) => {
  if (uid) {
    loginCometChat(dispatch);
  } else {
    logoutCometChat();
  }
};

export default (store) => observeStore(store, select, onChange);
